module.exports = __webpack_public_path__ + "img/17.84bbfeb3.png";